import { render, staticRenderFns } from "./IP_ByCDIStaff.vue?vue&type=template&id=2721053e&scoped=true&"
import script from "./IP_ByCDIStaff.vue?vue&type=script&lang=js&"
export * from "./IP_ByCDIStaff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2721053e",
  null
  
)

export default component.exports